import { locator } from "../helpers/common";
import { IGridRenderConfig, IScaleConfig, ITextScale, SvgElement } from "../types";
import { Scale } from "./Scale";
import { bottom, bottomGrid, left, leftGrid, right, rightGrid, top, topGrid } from "./SvgScales";
import { IFitPosition } from "@dhx/ts-common/html";

const renderScale = {
	left,
	right,
	bottom,
	top,
};
const renderGrid = {
	left: leftGrid,
	right: rightGrid,
	bottom: bottomGrid,
	top: topGrid,
};

export class TextScale extends Scale implements ITextScale {
	scaleReady(sizes: IFitPosition): void {
		const max = this._data.getLength() - 1;
		const steps = this._data.map(this.locator);
		this._axis = { max, steps };

		sizes[this._position] += this.config.size;
	}

	point(value: any): number {
		const pos = this._axis.steps.indexOf(value);
		if (this._padding) {
			const max = this._axis.max + 1;
			const padding = 0.5 / max;
			const point = pos / max;
			return this._isXDirection ? padding + point : 1 - padding - point;
		} else {
			return this._isXDirection ? pos / this._axis.max : 1 - pos / this._axis.max;
		}
	}

	paint(width: number, height: number): SvgElement {
		if (this.config.hidden) {
			return null;
		}

		const points = this._axis.steps.map((item, index) => [
			this._isXDirection ? this._getAxisPoint(index) * width : this.point(item) * height,
			item,
		]);
		return renderScale[this._position](points, this.config, width, height);
	}

	scaleGrid(): object {
		const getPoints = (width: number, height: number) =>
			this._axis.steps.map((item, index) => [
				this._isXDirection ? this._getAxisPoint(index) * width : this._getAxisPoint(index) * height,
				item,
			]);
		const type = this._position;
		const grid = this.config.grid;
		const dashed = this.config.dashed;
		const hidden = this.config.hidden;
		const getSpecificLevel = () => this._axis.steps.indexOf(this.config.targetLine);

		return {
			paint(width: number, height: number) {
				const targetLine = getSpecificLevel();
				const points = getPoints(width, height);
				const config: IGridRenderConfig = { targetLine, dashed, grid, hidden };
				return renderGrid[type](points, width, height, config);
			},
		};
	}

	protected _setDefaults(config: IScaleConfig) {
		const defaults = {
			scalePadding: 30,
			textPadding: 12,
			grid: true,
			targetLine: null,
			showText: true,
		};
		this.locator = locator(config.text);
		this.config = { ...defaults, ...config };
	}

	private _getAxisPoint(index) {
		const max = this._axis.max;
		if (this._padding) {
			const count = max + 1;
			const padding = 0.5 / count;
			const point = index / count;
			return this._isXDirection ? padding + point : 1 - padding - point;
		} else {
			return this._isXDirection ? index / max : 1 - index / max;
		}
	}
}
